<script setup lang="ts">
import { computed } from 'vue';
import { buildSealSvg, type SealAccent, type SealMetal } from './seal';

const props = defineProps<{
  metal: SealMetal;
  /** Engraved around the top arc; uppercased for the engraving. */
  topText: string;
  /** Brand-colour the quill emboss; omit for the plain metal emboss. */
  accent?: SealAccent | null;
  ariaLabel?: string;
}>();

// Each seal namespaces its SVG ids (gradients, text paths, masks) so several
// can coexist in one document without hijacking each other's defs.
const idSuffix = nextSealId();

const svg = computed(() =>
  buildSealSvg({
    metal: props.metal,
    topText: props.topText.toLocaleUpperCase(),
    accent: props.accent ?? null,
    idSuffix,
    ariaLabel: props.ariaLabel,
  }),
);
</script>

<script lang="ts">
let sealCount = 0;
// Hand out a document-unique suffix per seal instance.
function nextSealId() {
  sealCount += 1;
  return `bps${sealCount}`;
}
</script>

<template>
  <!-- The SVG is assembled from trusted constants; interpolated text is XML-escaped in buildSealSvg. -->
  <!-- eslint-disable-next-line vue/no-v-html -->
  <span class="billing-plan-seal" v-html="svg" />
</template>

<style lang="scss" scoped>
.billing-plan-seal {
  display: block;

  :deep(svg) {
    display: block;
    width: 100%;
    height: auto;
  }
}
</style>
